import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
  TextField,
  Container,
} from '@mui/material';
import { useGetStopWordsQuery, useSetStopWordsMutation } from '../redux/services/stopWordsApi';
import { useToast } from '../context/ToastContext';

const StopWords = () => {
  const { data: stopWordsResponse, isLoading, error } = useGetStopWordsQuery();
  const [setStopWords, { isLoading: isSaving }] = useSetStopWordsMutation();
  const { showToast } = useToast();
  const [text, setText] = useState('');

  React.useEffect(() => {
    if (stopWordsResponse) {
      // Handle different possible response formats
      let stopWordsArray = [];
      if (stopWordsResponse.msg) {
        // Handle the case where stop words are in the msg field
        stopWordsArray = stopWordsResponse.msg.split('\n').map(word => word.trim()).filter(word => word);
      } else if (Array.isArray(stopWordsResponse)) {
        stopWordsArray = stopWordsResponse;
      } else if (stopWordsResponse.data && Array.isArray(stopWordsResponse.data)) {
        stopWordsArray = stopWordsResponse.data;
      } else if (stopWordsResponse.stop_words && Array.isArray(stopWordsResponse.stop_words)) {
        stopWordsArray = stopWordsResponse.stop_words;
      } else if (typeof stopWordsResponse === 'string') {
        stopWordsArray = stopWordsResponse.split('\n').map(word => word.trim()).filter(word => word);
      }
      
      setText(stopWordsArray.join('\n'));
    }
  }, [stopWordsResponse]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      // Send the text directly without converting to array
      await setStopWords(text).unwrap();
      showToast('Stop words updated successfully!', 'success');
    } catch (err) {
      showToast('Failed to update stop words. Please try again.', 'error');
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  if (error) {
    return (
      <Container>
        <Typography color="error" sx={{ mt: 2 }}>
          Error loading stop words
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 3, mt: 4 }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Stop Words
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Enter stop words, one per line. These words will be ignored during processing.
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            multiline
            rows={20}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Enter stop words, one per line"
            variant="outlined"
            margin="normal"
            disabled={isSaving}
          />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSaving}
            >
              {isSaving ? (
                <>
                  <CircularProgress size={20} sx={{ mr: 1 }} />
                  Saving...
                </>
              ) : (
                'Save Stop Words'
              )}
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default StopWords; 